import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export default function CartEmptyInfo () {
  const { t: tc } = useTranslation('cart')

  return (
    <div className={styles.root}>
      <h3 className={styles.title}>{tc('preview.titleSelectedAddress')}</h3>
      <p className={styles.description}>{tc('preview.useSearchOrCatalog')}</p>
    </div>
  )
}
